import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/index.scss'
import '@multiplayer-app/ai-agent-react/style.css'

function render() {
  const container = document.getElementById('root')
  if (!container) throw new Error('Missing #root element')
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

// Gate rendering on the Office host being ready so Office.js is bound before the
// agent (and its Office tools) mount. `Office` is provided by the CDN script in
// index.html; guard for plain-browser dev where it may be absent.
if (typeof Office !== 'undefined' && Office.onReady) {
  Office.onReady().then(render)
} else {
  render()
}
